import React from 'react';
import { CSVLink } from 'react-csv'
import Button from 'react-bootstrap/Button';

export default function ExportReactCSV({csvData, headers, fileName}) {

    return (
        <Button variant="warning">
            <CSVLink data={csvData} headers={headers} filename={fileName}>Export</CSVLink>
        </Button>
    )
}